import Vue from 'vue'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(VueI18n)

let lang = navigator.language || navigator.userLanguage
lang = lang.substr(0, 2)
lang = lang === 'zh' || lang === 'en' ? lang : 'en'//only support zh and en
const i18n = new VueI18n({    //从localStorage中取，没有就默认浏览器所用的文字语言
    locale: localStorage.LANG || 'zh',
    messages: {
        en: {
            ...enLocale,
            ...elementEnLocale
        },
        zh: {
            ...zhLocale,
            ...elementZhLocale
        }
    },
    silentTranslationWarn: true,
}) 
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})
export default i18n
